import styled from '@emotion/styled';
import { css } from '@emotion/react';
import ArrowIcon from '../../../../public/static/arrow.svg';
import CalendarSVG from '../../../../public/static/icons/calendar.svg';
import { mediaQueries } from '../../../style/global-style';
import { getAssetsPrefix } from '../../../utils/buildVersion';
import { XIcon } from '../search-dropdown/search-dropdown.style';
import { DateTypes } from './calendar';

const assetPrefix = getAssetsPrefix();

export const StyledCalendarWrapper = styled.div<{ isModal: boolean; open: DateTypes }>`
    position: relative;
    color: black;
    display: flex;
    flex-direction: row;

    @media ${mediaQueries.phone} {
        box-shadow: rgba(0, 0, 0, 0.11) 0px 8px 7px 0px;
        border: 1px solid rgb(216, 216, 216);
    }

    ${(props) => {
        if (!props.open) return '';
        return css`
            ${props.isModal ? '> div:first-child' : '&'}::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                height: 3px;
                width: 50%;
                background-color: ${props.theme.colors.highlightBorder};
                border-radius: 1.5px;
                transition: ${`transform ${props.theme.transition.duration.modal}ms`};
                ${props.open === 'startDate'
                    ? css`
                          transform: translate3d(0, 1px, 0);
                      `
                    : props.open === 'endDate'
                    ? css`
                          transform: translate3d(100%, 1px, 0);
                      `
                    : null}
                z-index: 1;
            }
        `;
    }}
    ${(props) => (props.isModal ? '> div:first-child' : '&')} > div {
        width: 50%;
        position: relative;
        &:last-child {
            margin-right: 0;
        }
        input {
            width: 100%;
            height: 45px;
            border: 0;
            font-size: 14px;
            background-image: url('${assetPrefix}/static/icons/calendar.svg');
            padding-left: 30px;
            background-repeat: no-repeat;
            background-size: 17px 18px;
            background-position: 9px 12px;
            &:focus {
                background-color: #ffffff;
                color: ${(props) => props.theme.shades.lightGrey};
            }
        }
    }
    .DayPicker {
        &-Caption {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 5px;
            & > div {
                font-size: ${(props) => props.theme.fontSize.regular};
                font-weight: 600;
                text-transform: uppercase;
                color: #484848;
            }
        }
        &-Weekday {
            color: ${(props) => props.theme.shades.midGrey};
            font-size: 0.825em;
        }
        &-Day {
            font-size: 13px;
            border-radius: 0 !important;
            border: 0;
            color: ${(props) => props.theme.shades.blackGrey};
            width: 46px;
            height: 45px;
            padding: 1px;
            position: relative;

            @media ${mediaQueries.tabletAndUp} {
                width: 26px;
                height: 25px;
            }
            &:hover {
                background: ${(props) => props.theme.colors['main4-10']};
                color: ${(props) => props.theme.shades.darkGrey};
                border: 0;
            }
            &--disabled {
                color: ${(props) => props.theme.shades.lightGrey};
            }
            &--selected {
                /* color: white;

                border: 0;
                position: relative; */

                /* &:not(.DayPicker-Day--outside) {
                    background: rgba(0, 98, 149, 0.2);
                } */
            }

            &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                background: ${(props) => props.theme.colors.main4};
                position: relative;
                &:hover,
                &:active {
                    color: white;
                    background: ${(props) => props.theme.colors.main4};
                    border: 0;
                    position: relative;
                }
            }
            &--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(
                    .DayPicker-Day--outside
                ) {
                background: rgba(0, 98, 149, 0.2) !important;
                color: ${(props) => props.theme.shades.blackGrey};
            }
            &--start:not(.DayPicker-Day--outside),
            &--end:not(.DayPicker-Day--outside) {
                background: #006295 !important;
                color: white;
                &:hover,
                &:active {
                    color: white;
                    background: ${(props) => props.theme.colors.main4};
                    border: 0;
                    position: relative;
                }
            }
            &--start:not(.DayPicker-Day--outside) {
                /* border-top-left-radius: 50% !important;
                border-bottom-left-radius: 50% !important; */

                z-index: 1;
                &:after,
                &:before {
                    left: 19px;
                    top: 50%;
                    border: solid transparent;
                    content: ' ';
                    height: 0;
                    width: 0;
                    position: absolute;
                    pointer-events: none;
                }

                &:after {
                    border-color: rgba(136, 183, 213, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(-30deg);
                    z-index: -1;
                }
                &:before {
                    border-color: rgba(194, 225, 245, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(30deg);
                    z-index: -1;
                }
            }
            &--end:not(.DayPicker-Day--outside) {
                z-index: 1;
                &:after,
                &:before {
                    right: 19px;
                    top: 50%;
                    border: solid transparent;
                    content: ' ';
                    height: 0;
                    width: 0;
                    position: absolute;
                    pointer-events: none;
                }

                &:after {
                    border-color: rgba(136, 183, 213, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(-30deg) scale(-1);
                    z-index: -1;
                }
                &:before {
                    border-color: rgba(194, 225, 245, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(30deg) scale(-1);
                    z-index: -1;
                }
            }
        }
    }
    .DayPickerInput {
        display: block;
        &-Overlay {
            @media ${mediaQueries.phone} {
                height: calc(100vh - 90px);
                width: calc(100vw - 26px);
                box-shadow: none;
                overflow: visible;
                margin-top: 13px;
            }
            width: 100%;
            text-align: center;
            padding-bottom: 15px;
            z-index: 2;
        }
    }

    ${(props) => {
        if (!props.isModal) return '';
        return css`
            flex-direction: column;

            box-shadow: none !important;
            border: none !important;

            height: 100%;

            > div:first-child {
                position: relative;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                @media ${mediaQueries.phone} {
                    box-shadow: rgba(0, 0, 0, 0.11) 0px 8px 7px 0px;
                    border: 1px solid rgb(216, 216, 216);
                }
            }

            .DayPicker {
                overflow-y: scroll;

                .DayPicker-NavBar {
                    display: none;
                }
            }
        `;
    }}
`;

export const StyledStartDateWrapper = styled.div``;
const StyledArrow = styled(ArrowIcon)`
    fill: ${(props) => props.theme.shades.blackGrey};
    stroke: ${(props) => props.theme.shades.blackGrey};
    width: 40px;
    height: 32px;
    top: 10px;
    position: absolute;
    padding: 5px;
    cursor: pointer;
    @media ${mediaQueries.tabletAndUp} {
        width: 21px;
        height: 21px;
        top: 23px;
    }
`;
export const StyledArrowLeft = styled(StyledArrow)`
    transform: scale(-1);
    left: -16px;
    @media ${mediaQueries.tabletAndUp} {
        left: 10px;
    }
`;

export const StyledArrowRight = styled(StyledArrow)`
    right: -16px;
    @media ${mediaQueries.tabletAndUp} {
        right: 10px;
    }
`;
export const StyledEndDateWrapper = styled.div<{ hideSeparator: boolean }>`
    .DayPickerInput {
        &:before {
            content: '';
            width: 1px;
            height: 30px;
            background: #979797;
            position: absolute;
            top: 8px;
            display: ${(props) => (props.hideSeparator ? 'none' : 'block')};
        }
    }
`;

export const StyledXIcon = styled(XIcon)`
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translate(-15px, -50%);
    right: 0;
    cursor: pointer;
`;

export const StyledCalendarSVG = styled(CalendarSVG)<{ second?: string }>`
    position: absolute;
    width: 17px;
    height: 18px;
    z-index: 1;
    top: calc(50% - 1px);
    @media ${mediaQueries.phone} {
        left: ${(props) => (props.second === 'true' ? 'calc(50% + 17px)' : '17px')};
    }
    @media ${mediaQueries.tabletAndUp} {
        left: ${(props) => (props.second === 'true' ? 'calc(50% + 20px)' : '20px')};
    }
    transform: translate(-50%, -50%);
    fill: ${(props) => props.theme.shades.darkGrey};
    color: ${(props) => props.theme.shades.darkGrey};
`;

/** Customized styling */
export const StyledCalendar = styled.div<{ open?: DateTypes }>`
    position: relative;

    .CalendarDay {
        font-size: 13px;

        &__default {
            border: 0;
            color: ${(props) => props.theme.shades.blackGrey};

            &:hover {
                background: ${(props) => props.theme.colors['main4-10']};
                color: ${(props) => props.theme.shades.darkGrey};
                border: 0;
            }
        }
        &__hovered {
            &_offset {
                border: 0;
            }
            &_span,
            &_span:active,
            &_span:hover {
                background: ${(props) => props.theme.colors['main4-20']};
                color: ${(props) => props.theme.shades.darkGrey};
                border: 0;
            }
        }
        &__blocked {
            &_minimum_nights {
                border: 0;
            }
            &_calendar,
            &_calendar:active,
            &_calendar:hover {
                border: 0;
            }
            &_out_of_range {
                color: ${(props) => props.theme.shades.lightGrey};
            }
            &_out_of_range,
            &_out_of_range:active,
            &_out_of_range:hover {
                border: 0;
            }
        }
        &__selected {
            color: ${(props) => props.theme.shades.white};
            &_span {
                background: ${(props) => props.theme.colors['main4-20']};
                border: 0;
                color: ${(props) => props.theme.shades.blackGrey};

                &:active,
                &:hover {
                    background: ${(props) => props.theme.colors['main4-30']};
                    color: ${(props) => props.theme.shades.darkGrey};
                    border: 0;
                }
            }
            &:hover {
                color: ${(props) => props.theme.shades.white};
            }
            &_start {
                z-index: 1;
                &:after,
                &:before {
                    left: 19px;
                    top: 50%;
                    border: solid transparent;
                    content: ' ';
                    height: 0;
                    width: 0;
                    position: absolute;
                    pointer-events: none;
                }

                &:after {
                    border-color: rgba(136, 183, 213, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(-30deg);
                    z-index: -1;
                }
                &:before {
                    border-color: rgba(194, 225, 245, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(30deg);
                    z-index: -1;
                }
            }
            &_end {
                z-index: 1;
                &:after,
                &:before {
                    right: 19px;
                    top: 50%;
                    border: solid transparent;
                    content: ' ';
                    height: 0;
                    width: 0;
                    position: absolute;
                    pointer-events: none;
                }

                &:after {
                    border-color: rgba(136, 183, 213, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(-30deg) scale(-1);
                    z-index: -1;
                }
                &:before {
                    border-color: rgba(194, 225, 245, 0);
                    border-left-color: ${(props) => props.theme.colors.main4};
                    border-width: 12px;
                    margin-top: -12px;
                    transform: skewX(30deg) scale(-1);
                    z-index: -1;
                }
            }
        }
        &__selected,
        &__selected:active,
        &__selected:hover {
            background: ${(props) => props.theme.colors.main4};
            border: 0;
            position: relative;
        }
    }
    .DayPicker {
        &_weekHeader {
            top: 57px;

            &_li {
                color: ${(props) => props.theme.shades.midGrey};
            }
        }
        &__withBorder {
            box-shadow: none;
            border-radius: 0;
        }
    }
    .CalendarMonth {
        &_caption {
            strong {
                font-size: ${(props) => props.theme.fontSize.regular};
                font-weight: 600;
                text-transform: uppercase;
            }
        }
        &_table {
            margin-top: 5px;
        }
    }
    .DateRangePicker {
        &_picker {
            top: 45px !important;
            width: 100%;
        }
    }
    .DateRangePickerInput {
        display: flex;
        align-items: center;
        background-color: ${(props) =>
            props.open ? props.theme.shades.white : props.theme.shades['white-90']};

        &_arrow {
            display: flex;
            height: 30px;
        }

        ${(props) => {
            if (!props.open) return '';
            return css`
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 3px;
                    width: 50%;
                    background-color: ${props.theme.colors.highlightBorder};
                    border-radius: 1.5px;
                    transition: ${`transform ${props.theme.transition.duration.modal}ms`};
                    ${props.open === 'startDate'
                        ? css`
                              transform: translate3d(0, 1px, 0);
                          `
                        : props.open === 'endDate'
                        ? css`
                              transform: translate3d(100%, 1px, 0);
                          `
                        : null}
                    z-index: 1;
                }
            `;
        }}
    }
    .DateInput {
        flex: 1;
        position: relative;
        display: flex;
        background-color: transparent;

        &_fang {
            display: none;
        }
        &_input {
            font-family: NotoSans, Helvetica, sans-serif;
            padding: 0 0 0 40px;
            height: 45px;
            background-color: transparent;
            flex: 1;
            font-size: ${(props) => props.theme.fontSize.regularS};
            display: flex;
            border-bottom: ${(props) =>
                props.open ? `1px solid ${props.theme.shades.lightGrey}` : '1px solid transparent'};
        }

        /* In case we want to have nice animated blue line on focused field
        &:first-child:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 5px;
            left: 0;
            bottom: 0;
            background-color: ${(props) => props.theme.colors.highlightBorder};
            border-radius: 5px;
        }
        */
    }
`;
